
'use strict'

import Joint from './Joint.js';

import skinDataToGeometry from './skinDataToGeometry.js'

import OimoWrapper from './LaserOimoWrapper.js'

import JointMaterial from './JointMaterial.js'

import randomElement from './randomElement.js'

import getCustomDepthMaterial from './getCustomDepthMaterial.js'

import TWEEN from 'tween.js'

import JointTexture from './JointTexture.js'



var lerp = THREE.Math.lerp;

var mapLinear = THREE.Math.mapLinear;

var randf = THREE.Math.randFloat;



const isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

// StartAudioContext(Tone.context, '#container', ()=>{
//   // if(isSafari)  alert('StartAudioContext')
// });

var makeNote = ( name, duration, velocity) => {
  return {
    name: name,
    duration: duration || '32n',
    velocity: Math.min(velocity)
  }
}



var randf = THREE.Math.randFloat;

var Sketch = function(options){

  options = options || {};
  
  var debug = false;

  var updateVertexPositions = false;

  var elapsedTime = 0;

  var container = options.container || $("#container");

  var globeRad = 3;
  
  var goalPos = new THREE.Vector3( 0, 0, 0 );
  
  var attenuation = 0.99;
  
  var hingeRange = 60.0;

  var springRange = 60.0;

  var wigglyness = 1;
  
  var wigglySpeed = 6;
  
  var orig_wigglySpeed = wigglySpeed;
  
  var orig_wigglyness = wigglyness;
  
  var shadowRes = 2048;

  var attraction = 0.0125;

  var bodySmoothing = 0.25;

  var animationGoal = new THREE.Vector3( 0, 0, 0 );

  var darkColor = new THREE.Color(0x333742).multiplyScalar( 1.5 );


  // colors
  var c0 = new THREE.Color(0x000000);
  var c1 = new THREE.Color(0x111114);
  var orig_c0 = c0.clone();
  var orig_c1 = c1.clone();

  var textureLoader = new THREE.TextureLoader();

  var circleTex = textureLoader.load( './assets/ramp.png');

  // three
  var view = new ThreeView(container);// boiler plate... couldn't this be passed in? then we could do a player...

  var renderer = view.setupRenderer();

  if(!isSafari) {
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFShadowMap;// THREE.PCFSoftShadowMap;
  }
  renderer.setClearColor(0x333333, 0.1)

  var clock = new THREE.Clock();

  var scene = new THREE.Scene();
  scene.fog = new THREE.Fog( 0x000000, 50, 150 );

  var camera = new THREE.PerspectiveCamera(60, view.aspect, 1, 1000);
  camera.position.set(16, 55, 38);
  camera.lookAt( new THREE.Vector3(camera.position.x, camera.position.y-20, 0) );


  var controls = new THREE.OrbitControls( camera, renderer.domElement );
  // controls.enabled = false;
  controls.enableZoom = true;
  controls.enableRotate = false;
  controls.enablePan = true;
  controls.enableDamping = true;
  controls.dampingFactor = 0.5;
  controls.rotateSpeed = 0.5;
  controls.minDistance = globeRad + 4;
  controls.maxDistance = 240;

  controls.maxPolarAngle = Math.PI * 0.5;


  var spotLight = new THREE.SpotLight( 0xffffff, 2 );
  spotLight.position.set(0, 100, 0);
  spotLight.castShadow = true;
  spotLight.angle = Math.PI / 4;
  spotLight.penumbra = 1;
  spotLight.decay = 2;
  spotLight.distance = 200;
  spotLight.shadow.mapSize.width = shadowRes;
  spotLight.shadow.mapSize.height = shadowRes;
  spotLight.shadow.camera.near = 1;
  spotLight.shadow.camera.far = 200;

  spotLight.lookAt(new THREE.Vector3( 0, 0, 0 ) );
  scene.add(spotLight);


  var hemi = new THREE.HemisphereLight( 0x6688BB, 0x181844, 0.25 );
  scene.add( hemi );


  let box = new THREE.Mesh(new THREE.BoxGeometry(10,10,10), new THREE.MeshBasicMaterial({
    color: 'white',
    wireframe: true,
    side: 2
  }))



  var oc = new OimoWrapper({
    iterations: 20
  });
  oc.gravity.set(0, -100, 0);


  var groundBox = new THREE.Mesh(new THREE.BoxGeometry(1000, 40, 1000), new THREE.MeshPhongMaterial({
    color: darkColor
  }));

  groundBox.castShadow = false;
  groundBox.receiveShadow = true;
  scene.add(groundBox);

  var conf = [
    1, // The density of the shape.
    0.4, // The coefficient of friction of the shape.
    0.2, // The coefficient of restitution of the shape.
    1, // The bits of the collision groups to which the shape belongs.
    0xffffffff // The bits of the collision groups with which the shape collides.
  ];
  groundBox.body = oc.world.add({
    size: [400, 40, 400],
    pos: [0,-20,0],
    config: conf
  });

  var dragPlane = new THREE.Mesh(new THREE.PlaneGeometry( 300, 300, 10, 10), new THREE.MeshBasicMaterial( {
    color: 'magenta',
    wireframe: true
  } ));
  dragPlane.visible = false;

  scene.add(dragPlane)




  var dataTex = new THREE.DataTexture( new Uint8Array([255,0,255, 0,255,255]), 2, 1, THREE.RGBFormat)
  var updateDataTex = ()=>{

    let colorVals = c0.toArray().concat(c1.toArray());

    for(var i=0; i<colorVals.length; i++) {
      dataTex.image.data[i] = colorVals[i] * 255;
    }
    dataTex.needsUpdate = true;
  }
  updateDataTex();


  var skinLoader = new THREE.XHRLoader();
  skinLoader.setResponseType('json');
  

  // debug meshes
  let cube = new THREE.Mesh(new THREE.BoxGeometry(1,1,1), new THREE.MeshPhongMaterial({
    color: 'cyan',
    wireframe: true,
    transparent: true,
    opacity: 0.5,
    blending: 2
  }));


  let jointCube = new THREE.Mesh(cube.geometry, new THREE.MeshBasicMaterial( {
    color: 'red',
    wireframe: true
  } ) );
  jointCube.scale.multiplyScalar(0.5);

  var skins = [];
  var intersectables = [];


  var createSkin = (json, geometry) => {
    var skin = {
      skinObj: new THREE.Object3D(),
      raycastIntersects: [],
      rigidBodies: [],
      constraints: [],
      loaded: false,
      joints: [],
      geometry: null,
      material: null,
      mesh: null,
      jointTexture: null
    }

    var skinObj = skin.skinObj;
    scene.add(skinObj);

    // create the joints
    let jointMap = {}

    json['joints'].forEach( function( j ){
      
      let joint = new Joint({
        name: j.name,
        transform: new THREE.Matrix4().fromArray(j['transform']),
        rigidBody: j.rigidBody
      })

      skin.joints.push(joint);

      jointMap[j.name] = joint;

      // DEBUG
      if(debug)  joint.add(jointCube.clone());
    });


    // create the rigid bodies
    for(let i in json['rigidBodies']) {

      let data = json['rigidBodies'][i];
      
      let b = new THREE.Object3D();
      b.name = i
      b.applyMatrix(new THREE.Matrix4().fromArray(data['transform']))
      b.updateMatrixWorld(true);
      skinObj.add(b)
      skin.rigidBodies.push(b)
      
      let inv = new THREE.Matrix4().getInverse(b.matrixWorld)

      data.joints.forEach((j)=>{
        jointMap[j].applyMatrix(inv);
        b.add(jointMap[j])
      })

      // debug rigid body bounds
      let c = cube.clone();
      c.scale.multiply( new THREE.Vector3().fromArray(data['extents']) );
      c.visible = debug;
      b.add(c);

      // b.body = cc.addBoxMesh( c, {
      //   position: b.position,
      //   mass: data.mass,
      //   restitution: data.restitution,
      //   // material: groundMaterial
      // });

      b.body = oc.addFromMesh(c, 'box', {
        mass: data.mass
      });

      b.body.skin = skin;


      c.body = b.body;
      skin.raycastIntersects.push(c)
    }


    // set the initial joint offsets
    skinObj.updateMatrixWorld(true);

    skin.joints.forEach( j => {
      j.setOffset();
    });


    // create the constraints
    for(var i in json['constraints']) {

      let c = json["constraints"][i]
      let a = skinObj.getObjectByName(c['rigidBodyA']);
      let b = skinObj.getObjectByName(c['rigidBodyB'])
      
      let dataA = json['rigidBodies'][c['rigidBodyA']]
      let dataB = json['rigidBodies'][c['rigidBodyB']]
      
      let constraintPos = new THREE.Vector3().fromArray(c['translate']);

      if( a && b) {

          
        // local axis in rigid bodies
        let invA = new THREE.Matrix4().getInverse(a.matrixWorld)
        let invB = new THREE.Matrix4().getInverse(b.matrixWorld)

        let pointInA = constraintPos.clone().applyMatrix4(invA);
        let pointInB = constraintPos.clone().applyMatrix4(invB);

        let axisA = pointInA.clone().normalize();
        axisA.negate();


        let axisB = pointInB.clone().normalize();
        // axisB.negate();

        axisA.applyAxisAngle(new THREE.Vector3( 0, 1, 0 ), Math.PI * -0.5)
        axisB.applyAxisAngle(new THREE.Vector3( 0, 1, 0 ), Math.PI * -0.5)


        
        let constraint = oc.hingeJoint( a.body, b.body, {
          pointInA: pointInA,
          pointInB: pointInB,
          axisA: axisA, //new THREE.Vector3(1, 0, 0), // <-- this seems to be the axis the motor rotates on
          axisB: axisB, //new THREE.Vector3(1, 0, 0), // <-- this seems to be the axis the motor rotates on
          min: -hingeRange,
          max: hingeRange, 
          collision: false,
          spring: [-springRange , springRange ] 
        } );

        skin.constraints.push(constraint);

      }
    }


    // set the initial joint offsets
    skinObj.updateMatrixWorld(true);

    skin.joints.forEach( j => {
      j.setOffset();
    });


    // put together the mesh
    let jointTransforms = skin.joints.map(j => {
      return j.transform
    })


    let jointTexture = new JointTexture(jointTransforms);
    var jointMaterial = new JointMaterial(jointTransforms);

    // console.log( 'jointMaterial', jointMaterial, jointMaterial.fragmentShader );

    // jointMaterial.uniforms.hitColor.value.copy(c1)
    jointMaterial.uniforms.shininess.value = 128;
    jointMaterial.uniforms.reflectivity.value = 1;
    jointMaterial.uniforms.map.value = circleTex;
    jointMaterial.uniforms.jointTexture.value = jointTexture.texture;
    jointMaterial.uniforms.jointTextureDim.value.set( jointTexture.texture.image.width, jointTexture.texture.image.height);

    
    let mesh = new THREE.Mesh(geometry, jointMaterial);
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    mesh.customDepthMaterial = getCustomDepthMaterial(jointMaterial, jointTransforms)


    skinObj.add(mesh);
    skin.geometry = geometry;
    skin.material = jointMaterial;
    skin.material = jointMaterial;
    skin.mesh = mesh;
    skin.jointTexture = jointTexture;

    skin.loaded = true;

    intersectables = intersectables.concat(skin.raycastIntersects);

    return skin;
  }


  var animateSkin = (skin, index) => {

    let step = 1 / (skins.length)

    // color
    // skin.mesh.material.uniforms.hitColor.value.setHSL(step * skin.skinIndex, 1, 0.5)
  }



  skinLoader.load('assets/mesh.json', json => {

    $('#working').hide();

    let geometry = skinDataToGeometry(json);

    let count = isSafari ? 4 : 14;

    let rad = isSafari ? 10 : 40;

    let step = Math.PI * 2 / count;
    for (var i=0; i<count; i++) {

      let skin = createSkin(json, geometry);
      skins.push(skin);  

      skin.skinIndex = i;

      skin.rigidBodies.forEach( function( rb ){

        rb.body.position.x += Math.sin(i * step) * rad;
        rb.body.position.y = 10;
        rb.body.position.z += Math.cos(i * step) * rad;
      });  

    }


    skins.forEach( animateSkin );


    // for(let i=0; i<10; i++){
    //   cc.update(i * 0.1);
    // }
  
  });


  var updateSkin = skin => {


    skin.mesh.material.uniforms.time.value = elapsedTime;

    if (skin.loaded) {

      skin.joints.forEach( j => {
        j.updateTransform();
      });


      skin.constraints.forEach((c, i)=>{
        let l = Math.pow(Math.sin(elapsedTime + (i + skin.skinIndex) * 0.33), 3.0) * -2.0 + 1;
        c.limitMotor.lowerLimit = l - 0.1;
        c.limitMotor.upperLimit = l + 0.1;
      })


      skin.jointTexture.update();

      // rigid bodiy transforms
      var attractionDistance = 20;
      let delta = new THREE.Vector3(0, 0, 0);
      let q = new THREE.Quaternion();
      let attractor = new THREE.Vector3();

      skin.rigidBodies.forEach( (b, i)=>{

        // let localForce = new CANNON.Vec3(0, -3 * (Math.sin(elapsedTime + skin.skinIndex + i)),0);

        if (b.body) {

          b.body.linearVelocity.x *= attenuation;
          b.body.linearVelocity.y *= attenuation;
          b.body.linearVelocity.z *= attenuation; 
          
          b.body.angularVelocity.x *= attenuation;
          b.body.angularVelocity.y *= attenuation;
          b.body.angularVelocity.z *= attenuation;

          delta.copy(b.position);
          delta.sub(attractor);

          if(delta.length() > attractionDistance) {
            delta.normalize().multiplyScalar( attractionDistance );
          }

          if (!skin.grabbed) {
            b.body.linearVelocity.x -= delta.x * attraction;
            b.body.linearVelocity.y -= delta.y * attraction;
            b.body.linearVelocity.z -= delta.z * attraction;  
          }

          // if(i === 0) {
            
          // }
          
          b.position.lerp(b.body.getPosition(), bodySmoothing);
          q.copy(b.body.getQuaternion())
          b.quaternion.slerp(q, bodySmoothing);

        }

      });
    }
  }

  view.update = function(){

    // if(Tone.context.state && Tone.context.state === "suspended") {
    //   Tone.context.resume().then(function() {
    //     console.log("AudioContext resumed!");
    //     // fire your callback here
    //   });
    // }

    elapsedTime = clock.getElapsedTime();
    
    TWEEN.update();

    animationGoal.copy(camera.position).normalize().multiplyScalar( globeRad * 4 );

    oc.update();

    controls.update();
    
    skins.forEach( function( skin ){
    
      updateSkin(skin);
    
    });

    groundBox.position.copy(groundBox.body.getPosition())

    groundBox.quaternion.copy(groundBox.body.getQuaternion())
  };


  view.draw = function(){

    renderer.render(scene, camera, null, true);

  };


  view.onResize = function(){

    camera.aspect = view.aspect;
    camera.updateProjectionMatrix();

  };


  var raycaster = new THREE.Raycaster();
  var mouse = new THREE.Vector2();
  var mousedown = false;
  var dragging = false;
  var grabbed = false;
  var draggedBody, dragConstraint, grabbedSkin;



  var onPress = e => {

    mousedown = true;

    if(e.type === 'touchstart') {

      mouse.x = ( e.touches[0].pageX / window.innerWidth ) * 2 - 1;
      mouse.y = - ( e.touches[0].pageY / window.innerHeight ) * 2 + 1;

      if(e.touches.length > 1)  return;

    } else {
      mouse.x = ( e.pageX / window.innerWidth ) * 2 - 1;
      mouse.y = - ( e.pageY / window.innerHeight ) * 2 + 1;
    }

    raycaster.setFromCamera( mouse, camera );

    intersectables.forEach( function( m ){
      m.visible = true;
    });
    
    let intersects = raycaster.intersectObjects( intersectables );
    
    intersectables.forEach( function( m ){
      m.visible = debug;
    });

    if(intersects.length){

      grabbed = true;

      if(e.type === 'touchstart')  controls.enabled = false;
      controls.enableRotate = false;

      let skin = intersects[0].object.body.skin;

      skin.grabbed = true;
      grabbedSkin = skin;

      // grabbedSkin.mesh.material.uniforms.hitVal.value = 1

      let p = intersects[0].point;

      dragPlane.position.copy(p);
      dragPlane.lookAt(camera.position);

      if(p.length() < globeRad) {
        p.normalize().multiplyScalar( globeRad + 0.5 );
      }

      // debugSphere.position.copy(p)
      // debugSphere.body.position.copy(debugSphere.position);

      // dragConstraint = cc.addPointConstraint(
      //   intersects[0].object.body,
      //   new THREE.Vector3( 0, 0, 0 ),
      //   debugSphere.body,
      //   new THREE.Vector3( 0, 0, 0 ));
    }
  }

  var onRelease = e => {

    if(grabbed){
      // cc.removeConstraint(dragConstraint)
    }

    if(!controls.enableRotate) {
      controls.enabled = true;
      controls.enableRotate = true;
    }

    if(grabbedSkin) {


      if(!dragging) {

        let delta = camera.position.clone();
        delta.sub(grabbedSkin.rigidBodies[0].body.getPosition());

        delta.y = -Math.abs(delta.y);

        delta.normalize().multiplyScalar( 100 );

        grabbedSkin.rigidBodies[0].body.linearVelocity.x -= delta.x;
        grabbedSkin.rigidBodies[0].body.linearVelocity.y -= delta.y;
        grabbedSkin.rigidBodies[0].body.linearVelocity.z -= delta.z;

        let step = Math.PI * 2 / skins.length;
        grabbedSkin.mesh.material.uniforms.hitColor.value.setHSL(step * grabbedSkin.skinIndex, 1, 0.5)

        new TWEEN.Tween(grabbedSkin.mesh.material.uniforms.hitColor.value)
        .to(new THREE.Color(0x22ABFF), 1500)
        .start()
      }


      
      grabbedSkin.grabbed = false;

      grabbedSkin = false;
      
    }
    
    mousedown = false;
    
    grabbed = false;

    dragPlane.visible = false;

    dragging = false;
  }


  var dragIntersects = [dragPlane]

  var onDrag = e => {

    if(mousedown) dragging = true;

    // if(grabbed){

      // grabbedSkin.mesh.material.uniforms.hitVal.value = 2

      if(e.type === 'touchmove') {

        mouse.x = ( e.touches[0].pageX / window.innerWidth ) * 2 - 1;
        mouse.y = - ( e.touches[0].pageY / window.innerHeight ) * 2 + 1;


        if(e.touches.length > 1)  return;

      } else {
        mouse.x = ( e.pageX / window.innerWidth ) * 2 - 1;
        mouse.y = - ( e.pageY / window.innerHeight ) * 2 + 1;
      }

      raycaster.setFromCamera( mouse, camera );

      dragPlane.lookAt(camera.position)

      dragPlane.visible = true;
      let intersects = raycaster.intersectObjects(dragIntersects);
      dragPlane.visible = false;


      if(intersects.length){

        let p = intersects[0].point;


        if(p.length() < globeRad) {
          p.normalize().multiplyScalar( globeRad + 0.5 );
        } 
      }
  }


  $(window).on('mousedown', onPress)
  $(window).on('mouseup', onRelease)
  $(window).on('mousemove', onDrag)

  container.on('touchstart', onPress);
  container.on('touchend', onRelease);
  container.on('touchmove', onDrag);


  $(window).on('keypress', e=>{
    console.log( e );

    switch(e.key) {
      case 'd':
      case 'D':
        debug = !debug
        break;

      case 'c':
        console.log( camera );
        break;
    }
  })


  return {
    begin: function(){
      view.begin();
    }
  };

};



window.onload = () => {

  var sketch = new Sketch();

  sketch.begin();

};


